var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErServicesIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 6 6",
    style: {
      enableBackground: "new 0 0 6 6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FFFFFF;}\n\t.st1{fill:#1C2238;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.8,2.4H3.6V0.2C3.6,0.1,3.5,0,3.4,0c0,0,0,0,0,0H0.2C0.1,0,0,0.1,0,0.2v5.6C0,5.9,0.1,6,0.2,6h5.6 C5.9,6,6,5.9,6,5.8V2.6C6,2.5,5.9,2.4,5.8,2.4z M2.2,5.6H1.4V4.4h0.8C2.2,4.4,2.2,5.6,2.2,5.6z M3.2,2.6v3H2.6V4H1v1.6H0.4V0.4h2.8 C3.2,0.4,3.2,2.6,3.2,2.6z M5.6,5.6h-2V2.8h2V5.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.6,0.8H1.2v0.4h0.4V0.8z M2.4,0.8H2v0.4h0.4V0.8z M1.6,1.6H1.2V2h0.4C1.6,2,1.6,1.6,1.6,1.6z M2.4,1.6H2V2 h0.4C2.4,2,2.4,1.6,2.4,1.6z M1.6,2.4H1.2v0.4h0.4V2.4z M2.4,2.4H2v0.4h0.4V2.4z M4.4,3.2H4v0.4h0.4V3.2z M5.2,3.2H4.8v0.4h0.4V3.2z  M4.4,4H4v0.4h0.4C4.4,4.4,4.4,4,4.4,4z M5.2,4H4.8v0.4h0.4C5.2,4.4,5.2,4,5.2,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.2,0.2H0.8c-0.3,0-0.6,0.3-0.6,0.6l0,4.4c0,0.3,0.3,0.6,0.6,0.6h4.4c0.3,0,0.6-0.3,0.6-0.6V0.8 C5.8,0.4,5.6,0.2,5.2,0.2z M4.9,3.6H3.6v1.3H2.4V3.6H1.1V2.4h1.3V1.1h1.3v1.3h1.3V3.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErServicesIconColor);
export default __webpack_public_path__ + "static/media/er_services_icon_color.994b943483aa8d86f77bb2bea0a489a7.svg";
export { ForwardRef as ReactComponent };